import React from "react";
import {
  FaAnglesLeft,
  FaChevronLeft,
  FaChevronRight,
  FaAnglesRight,
} from "react-icons/fa6";

export default function Pagination({ meta, params, setParams }) {
  // Cek jika meta tidak ada atau halaman hanya 1
  if (!meta || meta?.last_page <= 1) return null;

  const currentPage = params.page;

  const handlePageChange = (newPage) => {
    // Validasi agar tidak reload halaman yang sama atau di luar range
    if (newPage === currentPage || newPage < 1 || newPage > meta.last_page) return;

    // Update params page. 
    // Hook useHookWaMessage akan mendeteksi perubahan ini dan otomatis fetch data.
    setParams((prev) => ({
      ...prev,
      page: newPage,
    }));
  };

  // Memfilter array links dari API
  // Kita menghilangkan tombol "Previous" & "Next" bawaan Laravel
  // karena kita membuat tombol navigasi custom sendiri.
  const pageLinks = meta?.links?.filter(
    (link) => link.label !== "&laquo; Previous" && link.label !== "Next &raquo;"
  ) || [];

  return (
    <div
      className="flex items-center justify-between px-5 py-3.5"
      style={{ borderTop: "1px solid rgba(51, 65, 85, 0.2)" }}
    >
      {/* Informasi Data */}
      <p className="text-xs text-slate-500">
        Menampilkan{" "}
        <span className="font-medium text-slate-300">{meta?.from ?? 0}</span> –{" "}
        <span className="font-medium text-slate-300">{meta?.to ?? 0}</span> dari{" "}
        <span className="font-medium text-slate-300">{meta?.total ?? 0}</span>
      </p>

      {/* Navigasi Halaman */}
      <nav className="flex items-center gap-1">
        {/* First Page */}
        <button
          onClick={() => handlePageChange(1)}
          disabled={currentPage === 1}
          className="rounded-lg p-2 text-slate-400 transition-all hover:bg-slate-700/40 hover:text-cyan-400 disabled:cursor-not-allowed disabled:opacity-30"
          aria-label="Halaman Pertama"
        >
          <FaAnglesLeft className="text-xs" />
        </button>

        {/* Previous Page */}
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="rounded-lg p-2 text-slate-400 transition-all hover:bg-slate-700/40 hover:text-cyan-400 disabled:cursor-not-allowed disabled:opacity-30"
          aria-label="Halaman Sebelumnya"
        >
          <FaChevronLeft className="text-xs" />
        </button>

        {/* Page Numbers */}
        {pageLinks.map((link, index) =>
          link.label === "..." ? (
            <span key={`ellipse-${index}`} className="px-2 text-sm text-slate-600">
              ···
            </span>
          ) : (
            <button
              key={link.label} // Laravel pagination links tidak punya 'id', gunakan label
              onClick={() => handlePageChange(Number(link.label))}
              className={`h-9 min-w-[34px] rounded-lg px-2 text-sm font-medium transition-all ${
                currentPage === Number(link.label)
                  ? "bg-cyan-600 text-white shadow-lg shadow-cyan-600/25"
                  : "text-slate-400 hover:bg-slate-700/40 hover:text-gray-100"
              }`}
            >
              {link.label}
            </button>
          )
        )}

        {/* Next Page */}
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === meta?.last_page}
          className="rounded-lg p-2 text-slate-400 transition-all hover:bg-slate-700/40 hover:text-cyan-400 disabled:cursor-not-allowed disabled:opacity-30"
          aria-label="Halaman Selanjutnya"
        >
          <FaChevronRight className="text-xs" />
        </button>

        {/* Last Page */}
        <button
          onClick={() => handlePageChange(meta?.last_page)}
          disabled={currentPage === meta?.last_page}
          className="rounded-lg p-2 text-slate-400 transition-all hover:bg-slate-700/40 hover:text-cyan-400 disabled:cursor-not-allowed disabled:opacity-30"
          aria-label="Halaman Terakhir"
        >
          <FaAnglesRight className="text-xs" />
        </button>
      </nav>
    </div>
  );
}